import { Text } from '@mnd-frontend/ui';
import { ExternalLink } from '../../../../../../../modules/global/components/Widgets/HelpPanel/components';

const SettingUpNewsroom = () => (
  <>
    <Text as="h3" variant="headlineSmall">
      Setting up your newsroom
    </Text>
    <Text as="p" variant="body" marginBottom="SPACING_2">
      When setting up your newsroom for the first time, you need to set some default
      functionalities. Everything you see in the newsroom can be changed, managed or pre-set from{' '}
      <i>Newsroom settings</i>. It’s also where you can turn on the newest features and set your
      newsroom’s brand colors.
    </Text>
    <Text as="h4" variant="labelMedium">
      Read more
    </Text>
    <ExternalLink
      link="https://help.mynewsdesk.com/sv/how-to/find-basics-settings-newsroom-settings/"
      text="Find the most basic settings for your newsroom"
      withBorder
    />
  </>
);

export default SettingUpNewsroom;
